import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const LoanClosedReasonUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted,
  onSubmit, onCancelClick,
  closingReason, onClosingReasonChange, closingReasonError, setClosingReasonError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Set closed reason'
    buttonLabel='Set'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextAreaSF type='text' name='closingReason' label='Closing Reason'
      value={closingReason} onChange={onClosingReasonChange}
      error={closingReasonError} setError={setClosingReasonError}
      required={true}
    />
  </ModalFormUI>

export default LoanClosedReasonUpdateModalUI
